<template>
  <div>
    <custom-actions show-back>
      <el-form :model="formData" :rules="rules" ref="form" class="mt30 global-form-label-width">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input v-model="formData.menuName" />
        </el-form-item>
        <el-form-item label="菜单编码" prop="menuCode">
          <el-input v-model="formData.menuCode" placeholder="请输入菜单编码" />
          <!-- <el-input :disabled="!!menuId" v-model="formData.menuCode" /> -->
        </el-form-item>
        <el-form-item label="叶子节点" prop="isLeaf">
          <el-radio-group v-model="formData.isLeaf">
            <el-radio label="1" border>是</el-radio>
            <el-radio label="0" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="formData.isLeaf === '1'" label="父级菜单" prop="parentMenuId">
          <el-cascader v-model="formData.parentMenuId" :props="{ label: 'menuName', value: 'menuId', children: 'childNode', checkStrictly: true, emitPath: false }"  :options="menus" placeholder="请选择"></el-cascader>
        </el-form-item>
        <el-form-item label="图标名称" prop="iconPath">
          <el-input v-model="formData.iconPath" />
        </el-form-item>
        <el-form-item label="菜单地址" prop="">
          <el-input v-model="formData.url" />
        </el-form-item>
        <el-form-item label="菜单排序">
          <el-input v-model="formData.orderNum" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio label="1" border>启用</el-radio>
            <el-radio label="2" border>不启用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="按钮权限" prop="button">
          <div class="quanxian">
            <el-input v-model="currentButton.butCode" placeholder="请输入code" />
            <el-input v-model="currentButton.butName" placeholder="请输入名称" />
            <el-button type="primary" @click="addButton">添加</el-button>
          </div>
          <div class="tags">
            <el-tag v-for="(item, index) of formData.buttonList" :key="index" type="primary" closable
              @close="delButton(index)">
              {{ item.butCode }} {{ item.butName }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'MenuAdd',
  data () {
    return {
      formData: {
        menuName: '',
        menuCode: '',
        menuType: '1',
        url: '',
        parentMenuId: '',
        iconPath: '',
        status: '1',
        orderNum: '',
        isLeaf: '1',
        buttonList: []
      },
      rules: {
        menuName: [{ required: true, message: '请输入菜单名称' }],
        isLeaf: [{ required: true, message: '请输入菜单名称' }],
        parentMenuId: [{ required: true, message: '请选择父级菜单' }]
      },
      menus: [],
      currentButton: {
        butCode: '',
        butName: ''
      }
    }
  },
  computed: {
    menuId () {
      return this.$route.query.id
    }
  },
  created () {
    this.loadMenus()
    if (this.menuId) {
      this.loadMenuDetails()
    }
  },
  methods: {
    loadMenus () {
      return this.$axios.get(this.$apis.system.selectIparkMenuTreeList, {
        params: {
          menuType: '1'
        }
      }).then(res => {
        this.menus = res
      })
    },
    loadMenuDetails () {
      this.$axios.get(this.$apis.system.selectSysMenuByMenuId, {
        params: {
          menuId: this.menuId
        }
      }).then(res => {
        this.formData = res
      })
    },
    addButton () {
      const button = JSON.parse(JSON.stringify(this.currentButton))
      this.formData.buttonList.push(button)
      this.currentButton.butCode = ''
      this.currentButton.butName = ''
    },
    delButton (index) {
      this.formData.buttonList.splice(index, 1)
    },
    save () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = this.menuId ? this.$apis.system.updateSysMenu : this.$apis.system.insertSysMenu
          this.$axios.post(url, this.formData).then(res => {
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-input {
  width: 400px;
}

.quanxian {
  display: flex;

  .el-input {
    width: 120px;
    margin-right: 10px;
  }
}

.tags {
  margin-top: 10px;

  .el-tag {
    margin-right: 10px;
  }
}
</style>
